import { Shield, Mail, FileText, Lock } from "lucide-react";
import logoUniversoDigital from "@/assets/logo-universo-digital-64.webp";
const Footer = () => {
  const currentYear = new Date().getFullYear();
  return <footer className="relative overflow-hidden gradient-hero py-12 text-white/90">
      {/* Background pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute inset-0" style={{
        backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.4'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`
      }} />
      </div>
      <div className="container-centered relative z-10">
        {/* Top Section */}
        <div className="flex flex-col items-center gap-8 text-center md:flex-row md:justify-between md:text-left">
          {/* Brand */}
          <div className="flex flex-col items-center md:items-start">
            <div className="flex items-center gap-3">
              <img alt="Universo Digital Academy" className="h-12 w-auto" width="48" height="48" loading="lazy" decoding="async" src="/lovable-uploads/245b0639-4418-4583-b998-cd456bbf3921.webp" />
              <span className="font-display text-lg font-bold text-white">
                Universo Digital Academy
              </span>
            </div>
            <p className="mt-2 text-base text-white/70">
              El Código del Crédito Perfecto - El Sistema Definitivo para Latinos
            </p>
          </div>

          {/* Links */}
          <div className="flex flex-wrap justify-center gap-6 text-base text-white/80">
            <a href="#" className="flex items-center gap-1 transition-colors hover:text-accent">
              <FileText className="h-4 w-4" />
              Términos de Uso
            </a>
            <a href="#" className="flex items-center gap-1 transition-colors hover:text-accent">
              <Lock className="h-4 w-4" />
              Política de Privacidad
            </a>
            <a href="#" className="flex items-center gap-1 transition-colors hover:text-accent">
              <Mail className="h-4 w-4" />
              Contacto
            </a>
          </div>
        </div>

        {/* Divider */}
        <div className="my-8 h-px bg-white/20" />

        {/* Bottom Section */}
        <div className="flex flex-col items-center gap-4 text-center text-base text-white/60 md:flex-row md:justify-between">
          <p>
            © {currentYear} Universo Digital Academy. Todos los derechos reservados.
          </p>
          <p className="max-w-md text-sm">
            Este producto no garantiza resultados específicos. Los resultados 
            pueden variar según la situación individual de cada persona. 
            Consulta con un profesional financiero para consejos personalizados.
          </p>
        </div>

        {/* Payment Methods */}
        <div className="mt-8 flex flex-col items-center gap-4">
          <p className="text-sm text-white/60">Métodos de pago aceptados:</p>
          <div className="flex flex-wrap items-center justify-center gap-4">
            <div className="rounded bg-white/10 px-3 py-2 text-sm font-medium text-white">
              Visa
            </div>
            <div className="rounded bg-white/10 px-3 py-2 text-sm font-medium text-white">
              Mastercard
            </div>
            <div className="rounded bg-white/10 px-3 py-2 text-sm font-medium text-white">
              American Express
            </div>
            <div className="rounded bg-white/10 px-3 py-2 text-sm font-medium text-white">
              PayPal
            </div>
            <div className="rounded bg-white/10 px-3 py-2 text-sm font-medium text-white">
              PIX
            </div>
          </div>
        </div>

        {/* Hotmart Badge */}
        <div className="mt-8 flex justify-center">
          <div className="flex items-center gap-2 rounded-full bg-white/10 px-4 py-2 text-base text-white">
            <Shield className="h-4 w-4 text-green-400" />
            <span>Vendido por Hotmart - Compra 100% Segura</span>
          </div>
        </div>
      </div>
    </footer>;
};
export default Footer;